import { tooltip } from './utilities'

// function to strip hyphenated text when copied and pasted in shopify search forms
export function stripHyphenatedText () {
  document.querySelectorAll('form[role="search"] input[type="search"]').forEach(searchInput => {
    searchInput.addEventListener('input', function (evt) {
      this.value = this.value.replace(/-/g, '')
    })
  })
}

// specific function for Zaner Bloser to show popup if user logged out
export function loggedOutPopup () {
  if (window.theme.settings.userID !== null) {
    return ''
  }
  const priceModal = new window.theme.Modals('PricePopup', 'price-popup')
  document.querySelector('.add-to-cart').addEventListener('click', (e) => {
    e.preventDefault()
    priceModal.open()
  })
  document.querySelector('.js-supadu-price-modal .add-to-cart').addEventListener('click', () => {
    priceModal.close()
  })
}

export function schoolPricesAccess () {
  if (window.theme.settings.userAccountType && (window.theme.settings.userAccountType === 'Homeschooler' || window.theme.settings.userAccountType === 'School' || window.theme.settings.userAccountType === 'Teacher')) {
    return true
  }
  return false
}

export function zbPricesString (variant) {
  if (!variant && !variant.price) {
    return ''
  }
  const variantPrice = (variant.price / 100).toFixed(2)
  const discount = variant.compare_at_price !== null ? ` <span class="product__price-discount"><strike>$${variant.compare_at_price.toFixed(2) / 100}</strike><span>` : ''
  return `$${variantPrice}${discount}`
}

export function zbPricesSection () {
  if (!window.theme.productData) {
    return ''
  }
  const isSchoolUser = schoolPricesAccess()
  const priceClass = isSchoolUser === true ? 'school-price' : 'retail-price'
  const priceTooltip = tooltip('School Price is 25% off Retail Price')

  let priceSection = ''
  let schoolPrice = ''
  let retailPrice = ''

  window.theme.productData.variants.forEach((variant) => {
    if (variant.title === 'School Price') {
      schoolPrice = `<p class="product__price-savings">${zbPricesString(variant)} <span class="text--small">School Price</span>${priceTooltip}</p>`
    }
    if (variant.title === 'Retail Price' || variant.title === 'Default Title') {
      retailPrice = `<p class="product__price-main">${zbPricesString(variant)} <span class="text--small">Retail Price</span></p>`
    }
  })
  if (retailPrice !== '' || schoolPrice !== '') {
    priceSection += `<div class='price__section ${priceClass}'>${retailPrice}${schoolPrice}</div>`
  }

  return priceSection
}

export function productWarning (item) {
  if (!item.custom || !item.custom.choking_hazard || item.custom.choking_hazard !== 'TRUE') {
    return false
  }
  return true
}
